import axios, { AxiosError, AxiosResponse } from 'axios';
import { addCancelToken, cancelTokenDict, CustomAxiosRequestConfig, removeCancelToken } from '../helpers/http.helper';

const cancelTokenRequestInterceptor = async function (config: any) {
   const isGetCall = config.method?.toLowerCase() === 'get';
   const shouldCancel = config.cancelable === false;
   if (shouldCancel || !isGetCall) return config;

   const existingCancelToken = cancelTokenDict[config.url!];
   if (existingCancelToken) {
      existingCancelToken.cancel();
   }
   const cancelToken = axios.CancelToken.source();
   config.cancelToken = cancelToken.token;

   addCancelToken(config.url, cancelToken);

   return config;
};

const cancelTokenResponseSuccessInterceptors = async function (response: AxiosResponse) {
   removeCancelToken(response?.config?.url);
   return response;
};
const cancelTokenResponseErrorInterceptors = async function (error: AxiosError) {
   return await Promise.reject(error);
};

export { cancelTokenRequestInterceptor, cancelTokenResponseSuccessInterceptors, cancelTokenResponseErrorInterceptors };
